export let MessageTypes = /*#__PURE__*/function (MessageTypes) {
  MessageTypes["StoresLocate"] = "stores:locate";
  MessageTypes["CommunityDeleteReaction"] = "community:delete-reaction";
  MessageTypes["CommunityAddReview"] = "community:add-review";
  MessageTypes["CommunityEditReview"] = "community:edit-review";
  MessageTypes["CommunityAddComment"] = "community:add-comment";
  MessageTypes["CommunityEditComment"] = "community:edit-comment";
  MessageTypes["CommunityLoadMoreReviews"] = "community:load-more-reviews";
  MessageTypes["CommunityToggleReviewForm"] = "community:toggle-review-form";
  MessageTypes["CommunityAddQuestion"] = "community:add-question";
  MessageTypes["CommunityEditQuestion"] = "community:edit-question";
  MessageTypes["CommunityAddDiscussion"] = "community:add-discussion";
  MessageTypes["CommunityEditDiscussion"] = "community:edit-discussion";
  MessageTypes["CommunityAddAnswer"] = "community:add-answer";
  MessageTypes["CommunityEditAnswer"] = "community:edit-answer";
  MessageTypes["CommunityLoadMoreQuestions"] = "community:load-more-questions";
  MessageTypes["CommunityToggleQuestionForm"] = "community:toggle-question-form";
  MessageTypes["CommunityLoadMoreDiscussions"] = "community:load-more-discussions";
  MessageTypes["CommunityToggleDiscussionForm"] = "community:toggle-discussion-form";
  MessageTypes["CommunityAddLike"] = "community:add-like";
  MessageTypes["CommunityDeleteLike"] = "community:delete-like";
  MessageTypes["CommunityAddKudo"] = "community:add-kudo";
  MessageTypes["CommunityDeleteKudo"] = "community:delete-kudo";
  MessageTypes["CommunitySetAlias"] = "community:set-alias";
  MessageTypes["LoginAuthenticate"] = "login:authenticate";
  MessageTypes["LoginTokenRenew"] = "login:token-renew";
  MessageTypes["LoginToggleFlyout"] = "login:toggle-flyout";
  MessageTypes["ArticlesProductNotFound"] = "articles:product-not-found";
  MessageTypes["RouterNavigate"] = "router:navigate";
  return MessageTypes;
}({});